import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 25,
    marginTop: 80,
    justifyContent: "center",
    alignItems: "center",
    alignSelf: "center",
    width: 340,
  },
  description: {
    textAlign: "justify",
    fontSize: 14,
    fontWeight: "400",
    lineHeight: 13,
  },
  btnText: {
    fontSize: 16,
    marginTop: 12,
  },
  btnAdd: {
    paddingVertical: 12,
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: 340,
    borderColor: "#077A97",
    borderWidth: 0.5,
    borderRadius: 4,
    marginTop: 20,
  },

  contentBtn: {
    alignSelf: "center",
    alignItems: "center",
    justifyContent: "center",
    width: 350,
  },
  btn: {
    fontFamily: "Poppins, sans-serif",
    padding: 10,
    width: 320,
    height: 38,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 4,
    backgroundColor: "#077A97",
    marginVertical: 12,
    alignSelf: "center",
    color: "#fff",
  },
  textBtn: {
    color: "#fff",
    textAlign: "center",
    fontSize: 18,
    fontWeight: "500",
  },
  contentBtnEmail: {
    position: "absolute",
    bottom: 30,
    paddingHorizontal: 25,
    width: "100%",
  },
  textBtnEmail: {
    color: "#2C2C2E",
    textAlign: "center",
    textDecorationLine: "underline",
    fontWeight: "normal",
  },
  centeredView: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    marginTop: 22,
  },
  modalCenteredView: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
  closeModal: {
    marginLeft: "auto",
    marginRight: -20,
  },
  modalView: {
    width: "auto",
    marginTop: 20,
    backgroundColor: "#ffffff",
    borderRadius: 20,
    paddingHorizontal: 35,
    paddingVertical: 15,
    alignItems: "center",
    overflow: "hidden",
    shadowOpacity: 0.2,
    shadowColor: "#000",
    shadowRadius: 0,
    shadowOffset: {
      width: 0,
      height: 0,
    },
  },

  imgUpload: {
    width: 160,
    height: 160,
    tintColor: "#077A97",
  },

  img: {
    width: 500,
    height: 500,
    marginTop: 50,
    borderRadius: 10,
    borderWidth: 1,
  },
});

export default styles;
